import { render, staticRenderFns } from "./AboutTable.vue?vue&type=template&id=6fa328ca&scoped=true"
import script from "./AboutTable.vue?vue&type=script&lang=js"
export * from "./AboutTable.vue?vue&type=script&lang=js"
import style0 from "./AboutTable.vue?vue&type=style&index=0&id=6fa328ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa328ca",
  null
  
)

export default component.exports